/* ============================================================================
   BGR — How It Works
   Minimal JS: opt-in scroll fade-in only. Uses the same fail-safe pattern as
   BGR's other sections — the hidden state is applied by this script itself,
   right before observing, so a JS failure never leaves content invisible.
   ============================================================================ */
(function () {
  'use strict';

  if (window.__bgrHiwInit) return;
  window.__bgrHiwInit = true;

  function initAnimations(root) {
    var scope = root || document;
    var sections = scope.querySelectorAll('.bgr-hiw--animate:not([data-bgr-hiw-observed])');
    if (!sections.length || !('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('bgr-hiw--in-view');
            entry.target.classList.remove('bgr-hiw--pre-animate');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
    );

    sections.forEach(function (section) {
      section.setAttribute('data-bgr-hiw-observed', 'true');
      section.classList.add('bgr-hiw--pre-animate');
      observer.observe(section);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAnimations(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initAnimations(event.target);
  });
})();